var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRouter = function SvgRouter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 14V10H13.0001V14H19.0001C19.5524 14 20.0001 14.4477 20.0001 15V21C20.0001 21.5523 19.5524 22 19.0001 22H5.00015C4.44786 22 4.00015 21.5523 4.00015 21V15C4.00015 14.4477 4.44786 14 5.00015 14H11.0001ZM2.51074 7.83686C3.83432 3.86424 7.58275 1 12.0001 1C16.4176 1 20.166 3.86424 21.4896 7.83686L19.5917 8.46949C18.5328 5.29139 15.5341 3 12.0001 3C8.46623 3 5.46749 5.29139 4.40862 8.46949L2.51074 7.83686ZM6.3065 9.1021C7.10065 6.71854 9.34971 5 12.0001 5C14.6506 5 16.8996 6.71854 17.6938 9.1021L15.7959 9.7347C15.2665 8.1457 13.7671 7 12.0001 7C10.2332 7 8.73382 8.1457 8.20439 9.7347L6.3065 9.1021Z",
    fill: "#32302F"
  })));
};
export default SvgRouter;